import { createHttpClient } from "./http";

export class UsuarioDistribuidorRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 300000 });
	}

	async save(data) {
		try {
			const result = await this.axios.post("usuario-distribuidor", data, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
					"Content-Type": "application/json",
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao salvar usuário.");
		}
	}

	async previaImportacao(unidadeDistribuidoraId, linhas) {
		try {
			const result = await this.axios.post(
				"usuario-distribuidor/importar/previa",
				{ unidadeDistribuidoraId, linhas },
				{ headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` } }
			);
			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");
			throw new Error(error.response?.data?.message || "Erro ao analisar a planilha.");
		}
	}

	async importar(unidadeDistribuidoraId, linhas) {
		try {
			const result = await this.axios.post(
				"usuario-distribuidor/importar",
				{ unidadeDistribuidoraId, linhas },
				{ headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` } }
			);
			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");
			throw new Error(error.response?.data?.message || "Erro ao importar usuários.");
		}
	}

	async update(data) {
		try {
			const result = await this.axios.patch("usuario-distribuidor", data, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
					"Content-Type": "application/json",
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao atualizar usuário.");
		}
	}

	async getAll(unidadeDistribuidoraId, page = 1, limit = 10, search = "", ativo = true) {
		try {
			// Construir filtro no formato esperado pelo backend
			const filter = {
				ativo: ativo,
				unidadesDistribuidoras: {
					some: {
						unidadeDistribuidoraId: unidadeDistribuidoraId
					}
				}
			};

			// Adicionar busca se houver
			if (search) {
				filter.OR = [
					{ nome: { contains: search, mode: 'insensitive' } },
					{ email: { contains: search, mode: 'insensitive' } },
					{ login: { contains: search, mode: 'insensitive' } }
				];
			}

			const filterValue = encodeURI(JSON.stringify(filter));
			const sortBy = encodeURI(JSON.stringify({ createdAt: 'desc' }));

			const result = await this.axios.get("usuario-distribuidor", {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				},
				params: {
					page,
					limit,
					filterValue,
					sortBy
				}
			});

			// Retornar no formato esperado pelo frontend
			return {
				data: result.data.usuarios || [],
				total: result.data.totalItems || 0,
				page: page,
				limit: limit,
				totalPages: result.data.totalPages || 0
			};
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error("Erro ao carregar usuários.");
		}
	}

	async getById(id) {
		try {
			const result = await this.axios.get(`usuario-distribuidor/${id}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				}
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");
			if(error.response?.status === 404)
				throw new Error("Usuário não encontrado.");

			throw new Error("Erro ao carregar usuário.");
		}
	}

	async toggleStatus(id) {
		try {
			const result = await this.axios.patch(`usuario-distribuidor/${id}/toggle-status`, null, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error("Erro ao alterar status do usuário.");
		}
	}
}
